/* OXXRING v2 site script: header, drawer, cart count, spec-aware search, shared size index. */
(function () {
  'use strict';

  var MAT = { N: ['NBR', 'nbr'], F: ['FKM', 'fkm'], K: ['FFKM', 'ffkm'], E: ['EPDM', 'epdm'], S: ['Silicone', 'silicone'] };
  var MAT_WORDS = [[/\b(ffkm|perfluoro\w*|kalrez)\b/i, 'K'], [/\b(fkm|fpm|viton|fluoro\w*)\b/i, 'F'], [/\b(nbr|nitrile|buna[\s-]?n?)\b/i, 'N'], [/\b(epdm)\b/i, 'E'], [/\b(silicone|vmq|mvq)\b/i, 'S']];

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function fmt(n, d) { return Number(n).toFixed(d); }
  function dash(s) { return String(s).replace('.', '-'); }

  /* ---------- shared data loaders (lazy, cached) ---------- */
  var cache = {};
  function loadJSON(url) {
    if (!url) return Promise.reject(new Error('no url'));
    if (!cache[url]) cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    return cache[url];
  }
  function sizeIndex(url) {
    var key = 'idx:' + url;
    if (!cache[key]) {
      cache[key] = loadJSON(url).then(function (data) {
        var rows = data.sizes.split(';').map(function (s) {
          var p = s.split(','); var codes = [];
          p[2].replace(/([A-Z])(\d{2})/g, function (_, m, h) { codes.push({ m: m, h: h }); return ''; });
          return { id: +p[0], cs: +p[1], ids: p[0], css: p[1], codes: codes };
        });
        return { rows: rows, x: data.x || {} };
      });
    }
    return cache[key];
  }
  function handleFor(index, row, code) {
    var k = row.ids + 'x' + row.css + code.m + code.h;
    return index.x[k] || ('o-ring-' + dash(row.ids) + 'x' + dash(row.css) + '-' + MAT[code.m][1] + '-' + code.h + 'a');
  }
  function exact(index, id, cs) {
    return index.rows.filter(function (r) { return Math.abs(r.id - id) < 0.006 && Math.abs(r.cs - cs) < 0.006; });
  }
  function nearby(index, id, cs, limit) {
    var out = [];
    index.rows.forEach(function (r) {
      var dId = r.id - id, dCs = r.cs - cs;
      if (Math.abs(dId) < 0.006 && Math.abs(dCs) < 0.006) return;
      var idTol = Math.max(0.3, id * 0.04);
      if (Math.abs(dId) <= idTol && Math.abs(dCs) <= 0.16) out.push({ row: r, dId: dId, dCs: dCs, score: Math.abs(dId) / idTol + Math.abs(dCs) / 0.16 });
    });
    return out.sort(function (a, b) { return a.score - b.score; }).slice(0, limit || 6);
  }
  window.OXXIC = { loadJSON: loadJSON, sizeIndex: sizeIndex, handleFor: handleFor, exact: exact, nearby: nearby, MAT: MAT };

  /* ---------- query parsing ---------- */
  function parse(raw) {
    var q = String(raw || '').trim();
    var t = q.replace(/[×✕*]/g, 'x').replace(/(\d),(\d)/g, '$1.$2').replace(/\s+/g, ' ');
    var out = { q: q };
    var m = t.match(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*x\s*(\d+(?:\.\d+)?)\s*(mm|in|inch|inches|")?/i);
    if (m) {
      out.unit = /^(in|inch|inches|")$/i.test(m[3] || '') || /\b(in|inch)\b|"/i.test(t.replace(m[0], '')) ? 'in' : 'mm';
      var f = out.unit === 'in' ? 25.4 : 1;
      out.id = +m[1] * f; out.cs = +m[2] * f; out.rawId = m[1]; out.rawCs = m[2];
    }
    // "2-014" / "2-214" is the common catalogue spelling of an AS568 dash number; the home quick-find already took it.
    var a = t.match(/\bas\s*-?\s*568\s*[-#]?\s*(\d{1,3})\b/i) || t.match(/^\s*[-#]?\s*(\d{3})\s*$/) || t.match(/(?:^|\s)-(\d{3})\b/) || t.match(/(?:^|\s)2-(\d{3})\b/);
    if (a && !out.id) out.dash = ('00' + a[1]).slice(-3);
    for (var i = 0; i < MAT_WORDS.length; i++) if (MAT_WORDS[i][0].test(t)) { out.mat = MAT_WORDS[i][1]; break; }
    var h = t.match(/\b(50|60|70|75|80|90)\s*(?:a\b|sh(?:ore)?\s*a?\b|duro)/i) || t.match(/\bshore\s*a?\s*(50|60|70|75|80|90)\b/i);
    if (h) out.hard = h[1];
    return out;
  }

  /* ---------- header: mega menu ---------- */
  function initNav(root) {
    var items = [].slice.call(root.querySelectorAll('[data-ic-nav-item]'));
    var timer;
    function close(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.removeAttribute('data-open');
        it.querySelector('.ic-nav__top').setAttribute('aria-expanded', 'false');
        it.querySelector('.ic-mega').hidden = true;
      });
    }
    function open(it) {
      close(it);
      it.setAttribute('data-open', '');
      it.querySelector('.ic-nav__top').setAttribute('aria-expanded', 'true');
      it.querySelector('.ic-mega').hidden = false;
    }
    items.forEach(function (it) {
      var btn = it.querySelector('.ic-nav__top');
      btn.addEventListener('click', function () { if (it.hasAttribute('data-open')) close(); else open(it); });
      it.addEventListener('mouseenter', function () { if (!window.matchMedia('(hover: hover)').matches) return; clearTimeout(timer); timer = setTimeout(function () { open(it); }, 90); });
      it.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { close(); }, 160); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var o = root.querySelector('[data-ic-nav-item][data-open] .ic-nav__top'); close(); if (o) o.focus(); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  }

  /* ---------- header: mobile drawer (links cloned from the mega menu) ---------- */
  function initDrawer(root) {
    var drawer = root.querySelector('[data-ic-drawer]');
    var openBtn = root.querySelector('[data-ic-drawer-open]');
    if (!drawer || !openBtn) return;
    root.querySelectorAll('[data-ic-drawer-links]').forEach(function (slot) {
      var mega = root.querySelectorAll('.ic-mega')[+slot.getAttribute('data-ic-drawer-links') - 1];
      if (!mega) return;
      var ul = el('ul');
      mega.querySelectorAll('.ic-mega__col ul a, .ic-mega__tool').forEach(function (a) {
        var s = a.querySelector('strong'), label = s ? s.textContent : '';
        if (!label) { for (var i = 0; i < a.childNodes.length; i++) { var n = a.childNodes[i]; var tx = n.nodeType === 3 ? n.textContent.trim() : (n.tagName === 'SPAN' && !n.className ? n.firstChild && n.firstChild.textContent.trim() : ''); if (tx) { label = tx; break; } } }
        if (!label) label = a.textContent.trim();
        var li = el('li'); var c = el('a', null, label.trim()); c.href = a.getAttribute('href'); li.appendChild(c); ul.appendChild(li);
      });
      slot.appendChild(ul);
    });
    var previousOverflow = '';
    function focusable() {
      return [].slice.call(drawer.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex]'))
        .filter(function (n) { return !n.disabled && n.tabIndex >= 0 && n.getClientRects().length; });
    }
    function set(open) {
      if (open && drawer.hidden) previousOverflow = document.documentElement.style.overflow;
      drawer.hidden = !open; openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : previousOverflow;
      if (open) { var f = focusable()[0]; if (f) f.focus(); } else openBtn.focus();
    }
    openBtn.addEventListener('click', function () { set(true); });
    drawer.querySelectorAll('[data-ic-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); set(false); return; }
      if (e.key !== 'Tab') return;
      var nodes = focusable(), first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { e.preventDefault(); return; }
      if (!drawer.contains(document.activeElement) || (e.shiftKey && document.activeElement === first)) {
        e.preventDefault(); (e.shiftKey ? last : first).focus();
      } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('focusin', function (e) {
      if (!drawer.hidden && !drawer.contains(e.target)) { var first = focusable()[0]; if (first) first.focus(); }
    });
  }

  /* ---------- cart count ---------- */
  function refreshCount() {
    fetch((window.routes && window.routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('[data-ic-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); }); })
      .catch(function () {});
  }
  function initCartCount() {
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCount);
    document.addEventListener('oxx:cart:changed', refreshCount);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });
  }

  /* ---------- spec-aware search ---------- */
  function initSearch(box) {
    var input = box.querySelector('[data-ic-search-input]');
    var panel = box.querySelector('[data-ic-search-panel]');
    var finder = box.getAttribute('data-finder-url');
    var rfq = box.getAttribute('data-rfq-url');
    var seq = 0, timer, active = -1;

    function hide() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function show() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function group(title) { var g = el('div', 'ic-search__group'); g.appendChild(el('div', 'ic-search__group-title', title)); return g; }
    function item(href, main, sub) {
      var a = el('a', 'ic-search__item'); a.href = href; a.setAttribute('role', 'option');
      a.appendChild(el('span', null, main)); if (sub) a.appendChild(el('small', null, sub)); return a;
    }
    function finderLink(p) {
      var u = finder + '&units=mm';
      if (p.id) u += '&id=' + fmt(p.id, 2) + '&cs=' + fmt(p.cs, 2);
      if (p.mat) u += '&material=' + (p.mat === 'S' ? 'SILICONE' : MAT[p.mat][0]);
      if (p.hard) u += '&hardness=' + p.hard;
      return u + '&source=header-search';
    }
    function rfqLink(p) {
      var u = rfq + '?source=header-search&request_mode=NEED_HELP&size_or_sku=' + encodeURIComponent(p.q.slice(0, 120));
      if (p.id) u += '&id=' + fmt(p.id, 2) + '&cs=' + fmt(p.cs, 2) + '&units=mm';
      return u;
    }

    function renderSize(frag, index, p) {
      var rows = exact(index, p.id, p.cs);
      var label = fmt(p.id, 2) + ' × ' + fmt(p.cs, 2) + ' mm';
      if (rows.length) {
        var g = group('Exact size · ' + label);
        var n = 0;
        rows[0].codes.forEach(function (c) {
          if (p.mat && c.m !== p.mat) return;
          if (p.hard && c.h !== p.hard) return;
          if (n++ >= 8) return;
          g.appendChild(item('/products/' + handleFor(index, rows[0], c), label + ' · ' + MAT[c.m][0] + ' ' + c.h + 'A', 'Exact size'));
        });
        if (!n) g.appendChild(el('div', 'ic-search__hint', 'This size is listed in other materials or hardness grades. Open the finder to compare them.'));
        g.appendChild(item(finderLink(p), 'Compare all ' + rows[0].codes.length + ' material / hardness options', 'Size finder'));
        frag.appendChild(g);
      } else {
        var none = group('No exact listing for ' + label);
        none.appendChild(el('div', 'ic-search__hint', 'Check the nearby sizes below, or send the size for a quote. Custom sizes are made to order.'));
        frag.appendChild(none);
      }
      var near = nearby(index, p.id, p.cs, 5);
      if (near.length) {
        var g2 = group('Nearby sizes · compare before ordering, not equivalent');
        near.forEach(function (n) {
          var d = 'ID ' + (n.dId >= 0 ? '+' : '') + fmt(n.dId, 2) + ' · CS ' + (n.dCs >= 0 ? '+' : '') + fmt(n.dCs, 2) + ' mm';
          var u = finder + '&units=mm&id=' + fmt(n.row.id, 2) + '&cs=' + fmt(n.row.cs, 2) + '&source=header-nearby';
          g2.appendChild(item(u, fmt(n.row.id, 2) + ' × ' + fmt(n.row.cs, 2) + ' mm', d));
        });
        frag.appendChild(g2);
      }
    }

    function render(p, index, as568, suggest, smart) {
      var frag = document.createDocumentFragment();
      // 1. what we understood (chips); the next step follows the exact-size results so a full spec still
      //    shows the product first
      if (smart && smart.chips.length > 1) {
        var u = el('div', 'ic-search__understood');
        u.appendChild(el('span', 'ic-search__understood-lbl', 'We understood'));
        smart.chips.forEach(function (c) { u.appendChild(el('span', 'ic-search__chip ic-search__chip--' + c.k, c.t)); });
        frag.appendChild(u);
      }
      var nextBlock = null;
      if (smart && smart.next.length) {
        nextBlock = group('Next step');
        smart.next.forEach(function (n) { var a = item(n.u, n.t, n.s); a.classList.add('ic-search__item--next'); nextBlock.appendChild(a); });
      }
      if (p.dash && as568) {
        var row = as568.rows.filter(function (r) { return r.d === p.dash; })[0];
        if (row) {
          var g = group('AS568 -' + p.dash + ' · public size reference');
          g.appendChild(el('div', 'ic-search__hint', 'Nominal ' + fmt(row.ii, 3) + '" × ' + fmt(row.ci, 3) + '" = ' + fmt(row.im, 2) + ' × ' + fmt(row.cm, 2) + ' mm'));
          frag.appendChild(g);
          p.id = row.im; p.cs = row.cm;
        }
      }
      if (p.id && index) renderSize(frag, index, p);
      if (nextBlock) frag.appendChild(nextBlock);
      // 2. typo-tolerant matches over tools, materials, media, applications and failure modes
      if (smart && smart.hits.length) {
        var byType = {};
        smart.hits.forEach(function (h) { (byType[h.type] = byType[h.type] || []).push(h); });
        Object.keys(byType).forEach(function (k) {
          var gs = group(smart.labels[k] || k);
          byType[k].slice(0, 4).forEach(function (h) { gs.appendChild(item(h.u, h.t, h.s)); });
          frag.appendChild(gs);
        });
      }
      if (suggest) {
        var prods = (suggest.products || []).filter(function (x) { return x && x.handle; }).slice(0, 5);
        if (prods.length) { var gp = group('Products'); prods.forEach(function (x) { gp.appendChild(item(x.url || '/products/' + x.handle, x.title)); }); frag.appendChild(gp); }
        var pages = (suggest.pages || []).concat(suggest.articles || []).slice(0, 4);
        if (pages.length) { var gg = group('Guides & pages'); pages.forEach(function (x) { gg.appendChild(item(x.url, x.title)); }); frag.appendChild(gg); }
        var cols = (suggest.collections || []).slice(0, 3);
        if (cols.length) { var gc = group('Collections'); cols.forEach(function (x) { gc.appendChild(item(x.url, x.title)); }); frag.appendChild(gc); }
      }
      var last = group('Can’t find it?');
      last.appendChild(item(rfqLink(p), 'Send “' + p.q.slice(0, 60) + '” as a quote request', 'We reply with options, including custom sizes'));
      frag.appendChild(last);
      panel.replaceChildren(frag);
      active = -1; input.removeAttribute('aria-activedescendant');
      panel.querySelectorAll('[role="option"]').forEach(function (o, i) { o.id = panel.id + '-option-' + i; o.setAttribute('aria-selected', 'false'); });
      show();
    }

    /* smart search add-on: FlexSearch + entity parser, loaded on first focus so the header stays light */
    var smartReady = null;
    function loadSmart() {
      if (smartReady) return smartReady;
      var srcs = (box.getAttribute('data-smart-js') || '').split('|').filter(Boolean);
      if (!srcs.length) return (smartReady = Promise.resolve(false));
      var one = function (src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.async = false; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); };
      smartReady = srcs.reduce(function (p, s) { return p.then(function () { return one(s); }); }, Promise.resolve())
        .then(function () { return window.OXXIC_SMART ? window.OXXIC_SMART.load(box.getAttribute('data-smart-docs')) : null; })
        .then(function () { return !!(window.OXXIC_SMART && window.OXXIC_SMART.ready()); })
        .catch(function () { return false; });
      return smartReady;
    }

    function update() {
      var raw = input.value.trim();
      var run = ++seq;
      if (raw.length < 2) { hide(); return; }
      var p = parse(raw);
      // The smart parser reads labelled forms the basic one cannot ("25mm ID 3mm", "ID 25 OD 31", "3 x 25"):
      // when it is loaded, its size / material / hardness win so the exact listing still shows first.
      if (window.OXXIC_Q) {
        var sp = window.OXXIC_Q.parse(raw);
        if (sp.id && sp.cs) { p.id = sp.id; p.cs = sp.cs; }
        if (sp.dash && !p.dash) p.dash = sp.dash;
        if (sp.mat && 'NFKES'.indexOf(sp.mat) > -1) p.mat = sp.mat;
        if (sp.hard) p.hard = sp.hard;
      }
      var needIndex = !!(p.id || p.dash);
      var hasWords = /[a-z]{3,}/i.test(raw.replace(/\b(mm|in|inch|x)\b/gi, ''));
      var jobs = [
        needIndex ? sizeIndex(box.getAttribute('data-index-url')).catch(function () { return null; }) : Promise.resolve(null),
        p.dash ? loadJSON(box.getAttribute('data-as568-url')).catch(function () { return null; }) : Promise.resolve(null),
        (p.id && !hasWords) ? Promise.resolve(null) :
          fetch('/search/suggest.json?q=' + encodeURIComponent(raw) + '&resources[type]=product,page,article,collection&resources[limit]=6&resources[options][unavailable_products]=last', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { return d && d.resources && d.resources.results; }).catch(function () { return null; }),
        loadSmart().then(function (ok) { return ok ? window.OXXIC_SMART.search(raw) : null; }).catch(function () { return null; })
      ];
      Promise.all(jobs).then(function (res) { if (run === seq) render(p, res[0], res[1], res[2], res[3]); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(update, 140); });
    input.addEventListener('focus', function () { loadSmart(); if (input.value.trim().length >= 2) update(); });
    input.addEventListener('keydown', function (e) {
      var opts = [].slice.call(panel.querySelectorAll('[role="option"]'));
      if (e.key === 'Escape') { hide(); return; }
      if (!opts.length || panel.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.setAttribute('aria-selected', String(i === active)); });
        input.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); opts[active].click(); }
    });
    box.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); hide(); input.focus(); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) hide(); });
    box.querySelector('form').addEventListener('submit', function (e) {
      // Size queries never fall through to keyword search: a full spec (size + material + hardness)
      // opens the exact product once the index is loaded; anything else opens the finder with the
      // size prefilled, where nearby sizes and the quote path are shown.
      var p = parse(input.value);
      var rest = input.value.replace(/\b(mm|in|inch|inches|x|as\s*-?568|shore|a)\b/gi, '').replace(/\b(nbr|fkm|fpm|epdm|ffkm|silicone|vmq|nitrile|buna|viton)\b/gi, '');
      if (!(p.id || p.dash) || /[a-z]{3,}/i.test(rest)) {
        // Text query: if the smart engine has one clear best match (a tool or a material) or a clear next step,
        // go there; otherwise fall through to the normal search page.
        if (window.OXXIC_SMART && window.OXXIC_SMART.ready()) {
          var s = window.OXXIC_SMART.search(input.value);
          var nx = s.next[0];
          if (nx && (s.p.media.length || s.p.symptoms.length) && s.chips.length > 1) { e.preventDefault(); window.location.href = nx.u; return; }
        }
        return;
      }
      e.preventDefault();
      var go = function (url) { window.location.href = url; };
      Promise.all([
        sizeIndex(box.getAttribute('data-index-url')),
        p.dash ? loadJSON(box.getAttribute('data-as568-url')) : Promise.resolve(null)
      ]).then(function (res) {
        if (p.dash && res[1]) { var r = res[1].rows.filter(function (x) { return x.d === p.dash; })[0]; if (r) { p.id = r.im; p.cs = r.cm; } }
        if (!p.id) return go('/search?type=product&q=' + encodeURIComponent(p.q));
        var row = exact(res[0], p.id, p.cs)[0];
        var hit = row && p.mat && p.hard && row.codes.filter(function (c) { return c.m === p.mat && c.h === p.hard; })[0];
        go(hit ? '/products/' + handleFor(res[0], row, hit) : finderLink(p));
      }).catch(function () { go(p.id ? finderLink(p) : '/search?type=product&q=' + encodeURIComponent(p.q)); });
    });
  }

  window.OXXIC.parse = parse;

  function boot() {
    document.querySelectorAll('[data-ic-header]').forEach(function (h) { initNav(h); initDrawer(h); });
    document.querySelectorAll('[data-ic-search]').forEach(initSearch);
    initCartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
